import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class DistrictIdInterceptor implements HttpInterceptor {
  intercept (request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const districtName = 'doenycny';
    request = request.clone({
      setHeaders: {
        'nv-district-id': districtName,
      },
    });
    return next.handle(request);
  }
}
